var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseForBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1317 2.98962C17.7175 2.40383 17.7175 1.45408 17.1317 0.868295C16.5459 0.282508 15.5962 0.282508 15.0104 0.868295L8.99997 6.87869L2.98957 0.868296C2.40379 0.28251 1.45404 0.282509 0.868252 0.868296C0.282466 1.45408 0.282466 2.40383 0.868252 2.98962L6.87865 9.00001L0.868234 15.0104C0.282448 15.5962 0.282447 16.546 0.868234 17.1318C1.45402 17.7175 2.40377 17.7175 2.98955 17.1318L8.99997 11.1213L15.0104 17.1318C15.5962 17.7175 16.5459 17.7175 17.1317 17.1318C17.7175 16.546 17.7175 15.5962 17.1317 15.0104L11.1213 9.00001L17.1317 2.98962Z",
    fill: "#101112"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseForBtn);
export default __webpack_public_path__ + "static/media/closeForBtn.9e42df8cb4079e0ac955dcb7ecc627f0.svg";
export { ForwardRef as ReactComponent };